import Api from '@/api/rest/MaterialCategoryApi';

export default new Api();
